import { globals } from '../globals'

declare const GLightbox
declare const google

export const dealersMapManager = (): void => {
  const allDealerBlocks = document.querySelectorAll('.js-dealers') as unknown as HTMLElement[]

  if (allDealerBlocks.length === 0) {
    return
  }

  for (let i = 0; i < allDealerBlocks.length; i++) {
    processDealerBlocks(allDealerBlocks[i])
  }
}

// Process all individual blocks
const processDealerBlocks = (dealerBlock: HTMLElement): void => {
  const themePath = globals.externalInput.wpBaseURL
  const headerElement = document.querySelector('.js-header') as unknown as HTMLElement

  // Main sidebar wrapper
  const dealerListWrapper = dealerBlock.querySelector('.js-dealers-listWrapper') as unknown as HTMLElement

  // List of all galleries
  const galleryList = dealerBlock.querySelectorAll('.js-dealer-gallery') as unknown as HTMLElement[]

  // Close buttons for individual dealers
  const closeDealerButtons = dealerBlock.querySelectorAll('.js-dealers-closeButton') as unknown as HTMLElement[]

  // Trigger short-delaer list
  const triggerList = Array.from(dealerBlock.querySelectorAll('.js-dealer-short')) as unknown as HTMLElement[]

  // Long dealer detail list
  const elementList = Array.from(dealerBlock.querySelectorAll('.js-dealer-full')) as unknown as HTMLElement[]

  let googleMap
  let googleMapMarkers

  // Process individual triggers being fired from anywhere (sidebar AND map IDs)
  const triggerDealer = (dealerID: string):void => {
    elementList.forEach((element: HTMLElement) => {
      element.classList.remove('-isActive')
    })
    dealerListWrapper.scrollTop = 0
    dealerListWrapper.classList.add('-hasActiveChild')
    const matchedElement = elementList.find((element: HTMLElement) => {
      return element.dataset.dealerId === dealerID
    })

    if (matchedElement) {
      matchedElement.classList.add('-isActive')
    }

    googleMapMarkers.forEach((marker) => {
      marker.setIcon(`${themePath}/assets/images/mapMarker-passive-swm.png`)
    })

    const matchedMarker = googleMapMarkers.find((element) => {
      return element.dealerId === dealerID
    })

    if (matchedMarker) {
      googleMap.setZoom(10)
      googleMap.setCenter(matchedMarker.getPosition())
      matchedMarker.setIcon(`${themePath}/assets/images/mapMarker-active-swm.png`)
    }
  }

  // Hooks up a single gallery sub-block
  const engageGallery = (gallery: HTMLElement): void => {
    const galleryTriggers = gallery.querySelectorAll('.js-dealer-galleryTrigger') as unknown as HTMLLinkElement[]
    const galleryTriggersList = [...galleryTriggers]
    const galleryItems = [] as {
    href: string
    type: string
  }[]

    galleryTriggers.forEach(trigger => {
      const newItem = {
        href: trigger.href,
        type: 'image'
      }
      galleryItems.push(newItem)

      // Add a trigger to each miniature to load the gallery
      trigger.addEventListener('click', (e) => {
        e.preventDefault()

        // Determine what index we open the gallery on
        const index = galleryTriggersList.findIndex(single => {
          return (single.href === trigger.href)
        })
        myGallery.settings.startAt = index

        // Open the gallery
        myGallery.open()
      })
    })

    // Load the actual gallery
    const myGallery = GLightbox({
      elements: galleryItems
    })
  }

  // Hooks up the google map
  const engageMap = (): void => {
    const googleMapElement = dealerBlock.querySelector('.js-dealers-map') as unknown as HTMLElement

    if (googleMapElement) {
      const mapLng = googleMapElement.dataset.mapLng as string
      const mapLat = googleMapElement.dataset.mapLat as string
      const mapZoom = googleMapElement.dataset.mapZoom as string

      googleMap = new google.maps.Map(googleMapElement, {
        center: {
          lat: Number(mapLat),
          lng: Number(mapLng)
        },
        zoom: Number(mapZoom),
        fullscreenControl: false,
        streetViewControl: false,
        mapTypeControl: false
      })

      googleMapMarkers = elementList.map(single => {
        const markerLat = single.dataset.dealerLat as string
        const markerLng = single.dataset.dealerLng as string
        const dealerId = single.dataset.dealerId as string
        const marker: {addListener: any} = new google.maps.Marker({
          position: {
            lat: Number(markerLat),
            lng: Number(markerLng)
          },
          map: googleMap,
          icon: `${themePath}/assets/images/mapMarker-passive-swm.png`,
          dealerId: dealerId
        })

        marker.addListener('click', () => {
          const wpAdminBar = document.querySelector('#wpadminbar') as HTMLElement

          const wpBarHeightScroll = (wpAdminBar && window.innerWidth > 600) ? wpAdminBar.clientHeight : 0

          const offset = dealerBlock.getBoundingClientRect().top + window.scrollY - wpBarHeightScroll - headerElement.clientHeight

          window.scroll({
            top: offset,
            behavior: 'smooth'
          })
          triggerDealer(dealerId)
        })

        return marker
      })
    }
  }

  // Set up all trigegrs from the sidebar
  triggerList.forEach((trigger: HTMLElement) => {
    trigger.addEventListener('click', (e) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (e.target.tagName.toLowerCase() === 'a') {
        return
      }

      const dealerID = trigger.dataset.dealerId
      if (dealerID) {
        triggerDealer(dealerID)
      }
    })
  })

  // Set trigger for close buttons
  closeDealerButtons.forEach((trigger: HTMLElement) => {
    trigger.addEventListener('click', () => {
      dealerListWrapper.scrollTop = 0
      elementList.forEach((element: HTMLElement) => {
        element.classList.remove('-isActive')
      })
      dealerListWrapper.classList.remove('-hasActiveChild')
      googleMapMarkers.forEach((marker) => {
        marker.setIcon(`${themePath}/assets/images/mapMarker-passive-swm.png`)
      })
    })
  })

  // Set up all galleries
  galleryList.forEach((gallery: HTMLElement) => {
    engageGallery(gallery)
  })

  // Load the map
  engageMap()
}
